import React from 'react'

import { Logo } from '@octane/spark'
import useUser from 'hooks/useUser'

import NavbarDropdown from './NavbarDropdown/NavbarDropdown'
import NavbarItem from './NavbarItem'

import './Navbar.css'

export interface NavbarProps {
    children?: React.ReactNode
}

export default function Navbar({ children }: NavbarProps): JSX.Element {
    const { isAutoDealership } = useUser()

    return (
        <nav className="Navbar" role="navigation">
            <div className="Navbar-container">
                <a
                    className="Navbar-brand"
                    href={isAutoDealership ? '#/dashboard' : '#'}
                >
                    <Logo
                        logo="lgOctaneDPPrimary"
                        color="#2366b1"
                        width={200}
                        height={50}
                    />
                </a>
                <ul className="Navbar-nav">{children}</ul>
            </div>
        </nav>
    )
}

Navbar.defaultProps = {
    children: null,
}

Navbar.Item = NavbarItem
Navbar.Dropdown = NavbarDropdown
